import React, { useRef, useState, useEffect } from "react";
import L, { LatLngExpression, LatLngBoundsExpression, LayerGroup, GPX, LatLngTuple } from "leaflet";
import 'leaflet-easyprint';
import { gpxList } from "../data/GPX";
import {} from "leaflet-gpx";
import {} from "maplibre-gl";
import {} from "leaflet-providers";
import { useLayer } from "./LayerContext";

import { getX } from "./helpers/getX";
import { baseLayers, basemaps } from "../data/baseLayers";
import { MapProps, StyledMap } from "./MapProps";
import { svgCityOutline } from "./helpers/svgCityOutline";
import { getAciveWays as displayAciveWays } from "./helpers/getAciveWays";
import { getActiveRoutes as displayActiveRoutes } from "./helpers/getActiveRoutes";
import { getActiveMarkers as displayActiveMarkers } from "./helpers/getActiveMarkers";
import {
  buildMetroRowerPopup,
  fetchMetroRowerAddress,
  getMetroRowerStationKey,
  getNextBike,
  MetroRowerAddressState,
  MetroRowerStation,
  readMetroRowerAddressCache,
  writeMetroRowerAddressCache
} from "./helpers/getNextBike";
import { getData } from "../helpers/getData";
import { isPointInGeoJson } from "../helpers/isPointInGeoJson";
import { options } from "../data/options";
import { getGPX } from "../helpers/getGPX";
import { createMapInDiv } from "./helpers/createMapInDiv";
import { svgOutnlineStyle } from "./svgOutnlineStyle";
import { layerIDs } from "./layerIDs";
import { LayerMarker, LayerMarkers } from "../data/layers";
import parking_icon from "./../static/icons/parking_sign_white.png";
import service_icon from "./../static/icons/service_sign_white.png";
import pumptrack_icon from "./../static/icons/bicycle_pumptrack.png"
import parking_icon_blue from "./../static/icons/parking_sign_icon_blue.png";
import traffic_park_icon from "./../static/icons/bicycle_training_station.png";
import bike_pump_icon from "./../static/icons/bikce_compressor_icons.png";
import nextbike_white_icon from "./../static/icons/nextbike_white.png";
import { poiBikeType, poiParkingType } from "../typings/global";

const iconsMap:any = (type:string) => {
  const iconMap:any = {
    "bicycle_training_station":traffic_park_icon,
    "bicycle_pumptrack":pumptrack_icon,
    "bicycle_repair_station":service_icon,
    "bike_pump": bike_pump_icon
  }
  return iconMap[type]
}

const stationLayerConfigs = [
  {
    id: "RepairStations",
    type: "bicycle_repair_station",
    icon: service_icon,
  },
  {
    id: "BikePumps",
    type: "bike_pump",
    icon: bike_pump_icon,
  },
  {
    id: "Pumptracks",
    type: "bicycle_pumptrack",
    icon: pumptrack_icon,
  },
  {
    id: "TrainingStations",
    type: "bicycle_training_station",
    icon: traffic_park_icon,
  },
] as const;

type LayerRefType = React.MutableRefObject<L.Map | undefined>

function getAllGPXTracks(gpxList:string[], mapRef: LayerRefType, layerGPXGroupRef: any): void {
  let totalDistance:number  = 0;
  gpxList.forEach((gpxFile) => {
    // const url = `http://localhost:3000/gpxs/${gpxFile}`; //TODO: to const - will not work on remote host
    const url = `/gpxs/${gpxFile}`; //TODO: to const - will not work on remote host
    if (layerGPXGroupRef && layerGPXGroupRef?.current) {
      getX(url).then(gpxObject => {
        const gpxFile = gpxObject.gpx;
        // options.polyline_options = gpxObject.style as L.PolylineOptions;
        const gpxLayer = new GPX(gpxFile,
          options //options > gpx_options; options > polyline_options
        )
        gpxLayer.on("loaded",  (e) => {
          const gpxTrack = e.target as L.GPX;
          totalDistance = totalDistance + gpxTrack.get_distance();
            //mapRef?.current.fitBounds(e.target.getBounds());
            //; //TODO: make interface or 
        }).addTo(layerGPXGroupRef?.current as L.LayerGroup);
        
      });
    }
  });
  
  // num.toFixed(2);
}

function isRouteGPX(gpxFile: string): boolean {
  return gpxFile.startsWith("Szlak_");
}

function PrintMapFunctionAdd(L:any, mapRef: any) {
  (L as any).easyPrint({
    title: 'Wydrukuj mapę rowerową',
    position: 'topleft',
    sizeModes: ['Current', 'A4Portrait', 'A4Landscape']
  }).addTo(mapRef.current);
}

// Map component
const MapLeaflet: React.FC<MapProps> = ({
  latitude,
  longitude,
  fullTitle,
  activeMarkers,
  activeWays,
  activeRoutes,
  bikeWayVisibility,
  setBounds,
  control,
  onMapReady

}) => {
  const { addLayer, layersList, setLayerLoading } = useLayer()

  const [SVGOutline, setSVGOutline] = useState(null);
  const [poi, setPoi] = useState(null);
  const [poiStacje, setStacjePoi] = useState<Array<poiBikeType> | undefined>();
  const [poiParking, setParkingPoi] = useState<Array<poiParkingType> | undefined>();
  const [poiNextBike, setPoiNextBike] = useState<MetroRowerStation[] | undefined>();
  const [metroRowerAddresses, setMetroRowerAddresses] = useState<Record<string, MetroRowerAddressState>>(() => {
    const savedCache = readMetroRowerAddressCache();

    return Object.entries(savedCache).reduce((result, [stationId, address]) => ({
      ...result,
      [stationId]: {
        address,
        loading: false,
      }
    }), {});
  });
  const [pbike, setPBike] = useState(null);

  const lcRef = useRef<L.Control>();
  const mapRef = useRef<L.Map>();
  const layerGroupRef = useRef<L.LayerGroup>(L.layerGroup());
  const layerPOIGroupRef = useRef<L.LayerGroup>(L.layerGroup());
  const layerPOIParkingGroupRef = useRef<L.LayerGroup>(L.layerGroup());
  const layerRepairStationsGroupRef = useRef<L.LayerGroup>(L.layerGroup());
  const layerBikePumpsGroupRef = useRef<L.LayerGroup>(L.layerGroup());
  const layerPumptracksGroupRef = useRef<L.LayerGroup>(L.layerGroup());
  const layerTrainingStationsGroupRef = useRef<L.LayerGroup>(L.layerGroup());
  const layerWaysGroupRef = useRef<L.LayerGroup>(L.layerGroup());
  const layerShapeGroupRef = useRef<L.LayerGroup>(L.layerGroup());
  const layerRouteGroupRef = useRef<L.LayerGroup>(L.layerGroup());
  const layerNextBikeGroupRef = useRef<L.LayerGroup>(L.layerGroup());
  const layerGPXGroupRef = useRef<L.LayerGroup>(L.layerGroup());

  const flatLayersList:React.MutableRefObject<string[] | undefined> = React.useRef();

  const context = useLayer();

  const stationLayerRefs: Record<string, React.MutableRefObject<L.LayerGroup>> = {
    RepairStations: layerRepairStationsGroupRef,
    BikePumps: layerBikePumpsGroupRef,
    Pumptracks: layerPumptracksGroupRef,
    TrainingStations: layerTrainingStationsGroupRef,
  };

  const wait = (ms: number) => new Promise((resolve) => {
    window.setTimeout(resolve, ms);
  });
  
  // Compute a string version of the map bounds for overpass API requests
  const updateBounds = () => {
    if (!mapRef.current) return;
    const mapBounds = mapRef.current.getBounds();
    const southWest = mapBounds.getSouthWest();
    const northEast = mapBounds.getNorthEast();
  };

  const stacjeicon = L.icon({
    iconUrl: './../static/icons/service_sign_white.png',
    iconSize: [40,40]
  }) //TODO: reakcja na zoom - grupowanie, powiększanie i zmiana ikony 

  const parkingicon = L.icon({
    iconUrl: './../static/icons/nextbike_white.png',
    iconSize: [40,40]
  }) //TODO: reakcja na zoom - grupowanie, powiększanie i zmiana ikony 

  // Initialize the map
  useEffect(() => {
    if (!mapRef.current) {
      const center: LatLngExpression = [latitude, longitude];
      // Create the map
      const basemap = basemaps.CartoDB_Positron;
      mapRef.current = createMapInDiv(center, basemap);
      // Keep the city boundary below route and bicycle-way overlays.
      const cityOutlinePane = mapRef.current.createPane("city-outline");
      cityOutlinePane.style.zIndex = "300";
      onMapReady?.(mapRef.current);
      PrintMapFunctionAdd(L, mapRef);

      const layerControl:L.Control = L.control.layers(baseLayers, {
        // "Pahts": layerGroupRef.current,
        // "POI": layerPOIGroupRef.current,
        // "Routes": layerRouteGroupRef.current,
        // "ways": layerWaysGroupRef.current,
        // "shape": layerShapeGroupRef.current,
        // "GPX": layerGPXGroupRef.current, 
      }).addTo(mapRef.current);
      layerControl.setPosition('topleft')

      control.current = layerControl;
      const container = layerControl.getContainer();
      const cc:L.Control.Layers = control.current;
      cc.options.collapsed = false;
      L.control.scale().addTo(mapRef.current);

      const localisation = L.marker(center);
      localisation.bindPopup(fullTitle);

      // Map bounds update listener //actually disabled 
      mapRef.current.on("moveend", updateBounds);
      updateBounds();
    }
  },[]);

  
  useEffect(() => {
    const routeGpxList = gpxList.filter((gpxFile) => isRouteGPX(gpxFile));

    //Albo w useEffect albo poza komponent - spróbuje oba
    const getParkingiPOI = () => getData('parkingi.json', setParkingPoi);
    const getStacjePOI = () => getData('stacje.json', setStacjePoi);
    const getSosnowiecBoundary = () => getData('sosnowiec.json', setSVGOutline);
    // const getGPX1 = () => getGPX('gpxs/Andresa-asfalt-5.gpx', setPBike)
  
    //To powinno iść do useEffect
    gpxList.forEach((gpxFile) => {
      const gpxPath = `gpxs/${gpxFile}`
      const getGPX1 = () => getGPX(gpxPath, setPBike)
    })

    getSosnowiecBoundary();
    // getGPX1();
    setLayerLoading("Nextbike", true);
    getNextBike()
      .then((metroRowerStations) => {
        setPoiNextBike(metroRowerStations);
        addLayer("Nextbike");
      })
      .catch(() => {
        setPoiNextBike([]);
        addLayer("Nextbike");
      })
      .finally(() => {
        setLayerLoading("Nextbike", false);
      });
    getParkingiPOI()
    getStacjePOI()
    getAllGPXTracks(routeGpxList, mapRef, layerRouteGroupRef)
  },[]);

  useEffect(() => {
    const flatedLayerList = layersList.map(((layer:any) => layer.id))

    if(flatedLayerList?.includes("ways")) {
      if(mapRef.current && layerWaysGroupRef.current) mapRef.current?.addLayer(layerWaysGroupRef.current)
    } else {
      if(mapRef.current && layerWaysGroupRef.current) mapRef.current?.removeLayer(layerWaysGroupRef.current)
    }

    if(flatedLayerList?.includes("shape")) {
      if(mapRef.current && layerShapeGroupRef.current) mapRef.current?.addLayer(layerShapeGroupRef.current)
    } else {
      if(mapRef.current && layerShapeGroupRef.current) mapRef.current?.removeLayer(layerShapeGroupRef.current)
    }

    if(flatedLayerList?.includes("Routes")) {
      if(mapRef.current && layerRouteGroupRef.current) mapRef.current?.addLayer(layerRouteGroupRef.current)
    } else {
      if(mapRef.current && layerRouteGroupRef.current) mapRef.current?.removeLayer(layerRouteGroupRef.current)
    }

    if(flatedLayerList?.includes("Nextbike")) {
      if(mapRef.current && layerNextBikeGroupRef.current) mapRef.current?.addLayer(layerNextBikeGroupRef.current)
    } else {
      if(mapRef.current && layerNextBikeGroupRef.current) mapRef.current?.removeLayer(layerNextBikeGroupRef.current)
    }

    if(flatedLayerList?.includes("Parkings")) {
      if(mapRef.current && layerPOIParkingGroupRef.current) mapRef.current?.addLayer(layerPOIParkingGroupRef.current)
    } else {
      if(mapRef.current && layerPOIParkingGroupRef.current) mapRef.current?.removeLayer(layerPOIParkingGroupRef.current)
    }

    stationLayerConfigs.forEach((layerConfig) => {
      const layerRef = stationLayerRefs[layerConfig.id];
      if(flatedLayerList?.includes(layerConfig.id)) {
        if(mapRef.current && layerRef.current) mapRef.current?.addLayer(layerRef.current)
      } else {
        if(mapRef.current && layerRef.current) mapRef.current?.removeLayer(layerRef.current)
      }
    });

  },[layersList])


  useEffect(() => {
    let newMarkers:LayerMarkers;
    if(poiParking && poiParking.length > 0) {
      const convertedPoi:LayerMarker[] = poiParking
      .filter((poiPoint: poiParkingType) => {
        const location = poiPoint.location as LatLngTuple;
        return isPointInGeoJson(location, SVGOutline as any);
      })
      .map((poiPoint:poiParkingType) => {
        const [lat, lng] = poiPoint.location as LatLngTuple;
        return { 
          'lat': lat,
          'lon': lng,
          'name': poiPoint.name,
        } as LayerMarker
      })

      newMarkers = {
        'key': 'paring_place',
        'icon': parking_icon,
        'markers': convertedPoi
      }

      if (convertedPoi.length > 0) {
        const renderParkingMarkers = () => displayActiveMarkers(layerPOIParkingGroupRef, mapRef.current, [newMarkers]);
        renderParkingMarkers();
        mapRef.current?.on("zoomend", renderParkingMarkers);
        mapRef.current?.on("moveend", renderParkingMarkers);
        addLayer("Parkings");

        return () => {
          mapRef.current?.off("zoomend", renderParkingMarkers);
          mapRef.current?.off("moveend", renderParkingMarkers);
        };
      }
    }
  }, [poiParking, SVGOutline]);

  useEffect(() => {
    if(poiStacje && poiStacje?.length > 0) {
      const filteredPoi = poiStacje.filter((poiPoint: poiBikeType) => {
        const location = poiPoint.location as LatLngTuple;
        return isPointInGeoJson(location, SVGOutline as any);
      });

      const renderCallbacks: Array<() => void> = [];

      stationLayerConfigs.forEach((layerConfig) => {
        const convertedPoi:LayerMarker[] = filteredPoi
        .filter((poiPoint: poiBikeType) => poiPoint.type === layerConfig.type)
        .map((poiPoint:poiBikeType) => {
          const [lat, lng] = poiPoint.location as LatLngTuple;
          return {
            'lat': lat,
            'lon': lng,
            'name': poiPoint.name,
            'icon': layerConfig.icon
          } as LayerMarker
        });

        if (convertedPoi.length > 0) {
          const newMarkers:LayerMarkers = {
            'key': layerConfig.type,
            'icon': layerConfig.icon,
            'markers': convertedPoi
          };

          const layerRef = stationLayerRefs[layerConfig.id];
          const renderStationMarkers = () => displayActiveMarkers(layerRef, mapRef.current, [newMarkers]);
          renderStationMarkers();
          mapRef.current?.on("zoomend", renderStationMarkers);
          mapRef.current?.on("moveend", renderStationMarkers);
          addLayer(layerConfig.id);
          renderCallbacks.push(renderStationMarkers);
        }
      });

      if (renderCallbacks.length > 0) {
        return () => {
          renderCallbacks.forEach((renderStationMarkers) => {
            mapRef.current?.off("zoomend", renderStationMarkers);
            mapRef.current?.off("moveend", renderStationMarkers);
          });
        };
      }
    }
  }, [poiStacje, SVGOutline]);

  useEffect(() => {
    const renderActiveMarkers = () => displayActiveMarkers(layerGroupRef, mapRef.current, activeMarkers);
    renderActiveMarkers();
    mapRef.current?.on("zoomend", renderActiveMarkers);
    mapRef.current?.on("moveend", renderActiveMarkers);

    return () => {
      mapRef.current?.off("zoomend", renderActiveMarkers);
      mapRef.current?.off("moveend", renderActiveMarkers);
    };
  }, [activeMarkers]);

  useEffect(() => {
    displayActiveRoutes(layerRouteGroupRef, activeRoutes);
  },[activeRoutes]);

  useEffect(() => {
    displayAciveWays(layerWaysGroupRef, activeWays, bikeWayVisibility);
    addLayer("ways");
  }, [activeWays, bikeWayVisibility])

  useEffect(() =>{
    if(SVGOutline) {
      svgCityOutline(SVGOutline, layerShapeGroupRef, svgOutnlineStyle, mapRef);
      addLayer("shape");
    }
  },[SVGOutline])

  useEffect(() => {
    const filteredStations = (poiNextBike || []).filter((station) =>
      SVGOutline
        ? isPointInGeoJson([station.location[1], station.location[0]], SVGOutline as any)
        : false
    );

    if (filteredStations.length === 0) {
      return;
    }

    const cachedAddresses = readMetroRowerAddressCache();
    const cachedStateEntries = filteredStations.reduce<Record<string, MetroRowerAddressState>>((result, station) => {
      const stationKey = getMetroRowerStationKey(station);
      const cachedAddress = cachedAddresses[stationKey];

      if (!cachedAddress) {
        return result;
      }

      return {
        ...result,
        [stationKey]: {
          address: cachedAddress,
          loading: false,
        }
      };
    }, {});

    if (Object.keys(cachedStateEntries).length > 0) {
      setMetroRowerAddresses((previousState) => ({
        ...previousState,
        ...cachedStateEntries,
      }));
    }

    const stationsToFetch = filteredStations.filter((station) => {
      const stationKey = getMetroRowerStationKey(station);

      return !cachedAddresses[stationKey];
    });

    if (stationsToFetch.length === 0) {
      return;
    }

    setMetroRowerAddresses((previousState) => ({
      ...previousState,
      ...stationsToFetch.reduce<Record<string, MetroRowerAddressState>>((result, station) => {
        const stationKey = getMetroRowerStationKey(station);

        return {
          ...result,
          [stationKey]: previousState[stationKey] || {
            address: null,
            loading: true,
          }
        };
      }, {})
    }));

    let cancelled = false;

    (async () => {
      const nextCache = { ...cachedAddresses };

      for (const station of stationsToFetch) {
        if (cancelled) {
          return;
        }

        const stationKey = getMetroRowerStationKey(station);
        const resolvedAddress = await fetchMetroRowerAddress(station.location);

        if (cancelled) {
          return;
        }

        if (resolvedAddress) {
          nextCache[stationKey] = resolvedAddress;
          writeMetroRowerAddressCache(nextCache);
        }

        setMetroRowerAddresses((previousState) => ({
          ...previousState,
          [stationKey]: {
            address: resolvedAddress,
            loading: false,
          }
        }));

        await wait(1100);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [poiNextBike, SVGOutline]);

  useEffect(() =>{
    const filteredStations = (poiNextBike || []).filter((station) =>
      SVGOutline
        ? isPointInGeoJson([station.location[1], station.location[0]], SVGOutline as any)
        : false
    );

    const newMarkers:LayerMarkers = {
      'key': 'metrorower',
      'icon': '',
      'markers': filteredStations.map((station) => ({
        lat: station.location[0],
        lon: station.location[1],
        name: station.name,
        popupHtml: buildMetroRowerPopup(
          station,
          metroRowerAddresses[getMetroRowerStationKey(station)]
        ),
        icon: nextbike_white_icon,
        position: station.location
      }))
    };

    const renderMetroRowerMarkers = () => displayActiveMarkers(layerNextBikeGroupRef, mapRef.current, [newMarkers]);
    renderMetroRowerMarkers();
    mapRef.current?.on("zoomend", renderMetroRowerMarkers);
    mapRef.current?.on("moveend", renderMetroRowerMarkers);

    return () => {
      mapRef.current?.off("zoomend", renderMetroRowerMarkers);
      mapRef.current?.off("moveend", renderMetroRowerMarkers);
    };
  },[metroRowerAddresses, poiNextBike, SVGOutline])


  // Render the map
  return <StyledMap id="leaflet-map" />;
};

export default MapLeaflet;
